import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import ValidationIdSuccessView from '../../../components/views/mx/farrera/ValidationIdSuccessView';
import {State} from '../../../types/mx/reducers';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {};
};

const ValidationIdSuccessContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidationIdSuccessView);

export default ValidationIdSuccessContainer;
